(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  function initStickyBar(bar) {
    if (!bar || bar.dataset.ppInitialized === 'true') return;
    const sectionId = bar.dataset.sectionId;
    const nativeButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const stickyButton = bar.querySelector('[data-pp-sticky-button]');
    const stickyPrice = bar.querySelector('[data-pp-sticky-price]');
    const productInfo = document.getElementById(`MainProduct-${sectionId}`) || bar.closest('product-info');
    if (!nativeButton || !stickyButton || !productInfo) return;
    bar.dataset.ppInitialized = 'true';
    let nativeButtonVisible = true;
    let syncQueued = false;
    const getPriceElement = () => productInfo.querySelector(`#price-${CSS.escape(sectionId)} .price__sale .price-item--sale`) || productInfo.querySelector(`#price-${CSS.escape(sectionId)} .price-item--regular`);
    const sync = () => {
      syncQueued = false;
      const nativeLabel = nativeButton.querySelector('span')?.textContent?.trim();
      const priceElement = getPriceElement();
      const disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
      stickyButton.setAttribute('aria-disabled', String(disabled));
      if (nativeLabel) stickyButton.textContent = nativeLabel;
      if (priceElement && stickyPrice) stickyPrice.textContent = priceElement.textContent.trim();
    };
    const queueSync = () => { if (!syncQueued) { syncQueued = true; requestAnimationFrame(sync); } };
    const updateVisibility = () => {
      const show = window.matchMedia(MOBILE_QUERY).matches && !nativeButtonVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('pp-sticky-atc-visible', show);
    };
    stickyButton.addEventListener('click', () => { if (!stickyButton.disabled) nativeButton.click(); });
    const intersectionObserver = new IntersectionObserver(([entry]) => { nativeButtonVisible = entry.isIntersecting; updateVisibility(); }, { threshold: 0.1 });
    intersectionObserver.observe(nativeButton);
    const buttonObserver = new MutationObserver(queueSync);
    buttonObserver.observe(nativeButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true });
    productInfo.addEventListener('change', () => { setTimeout(queueSync, 0); setTimeout(queueSync, 150); });
    window.addEventListener('resize', updateVisibility, { passive: true });
    window.addEventListener('pageshow', () => { queueSync(); updateVisibility(); });
    sync();
    updateVisibility();
  }
  function init() { document.querySelectorAll('[data-pp-sticky-atc]').forEach(initStickyBar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
